module.exports = (function ($, window) {
    // Define the colours
    var colours = [
        ['#5cc9bc', '#367c88', '#d5e9a2'],
        ['#5cc9bc', '#367c88', '#d5e9a2'],
        ['#5cc9bc', '#367c88', '#d5e9a2'],
        ['#5cc9bc', '#367c88', '#d5e9a2']
    ];

    // The Charts functionality
    window.Charts = {
        selectors: {
            charts: '.dashboard--chart'
        },
        /**
         * Initiate the charts.
         */
        init: function (data) {
            this.charts().each(function (i) {
                var data = '#' + $(this).attr('id') + '-json';
                data = $.trim($(data).html());
                data = JSON.parse(data);

                // Create the chart
                Morris.Donut({
                    element: this,
                    colors: colours[i],
                    data: data,
                    resize: true
                });
            });
        },

        charts: function () {
            return $(this.selectors.charts);
        },
    }
})(jQuery, window);



// WEBPACK FOOTER //
// ./resources/assets/js/components/charts.js